import type { Signal } from '@angular/core';
import { computed, signal } from '@angular/core';

export interface CollapsibleItems<T> {
	visibleItems: Signal<T[]>;
	hasMoreItems: Signal<boolean>;
	showMore(): void;
}

/** Shows at most `limit` items until `showMore` reveals the rest. */
export function collapsibleItems<T>(
	items: Signal<T[]>,
	limit: Signal<number>,
): CollapsibleItems<T> {
	const expanded = signal(false);

	return {
		visibleItems: computed(() =>
			expanded() ? items() : items().slice(0, limit()),
		),
		hasMoreItems: computed(() => !expanded() && items().length > limit()),
		showMore: () => expanded.set(true),
	};
}
